export default __webpack_public_path__ + "c9d3f93a65f5439664723042e1acde48.png";